import useDate from './../useDate'
const DateTransform = (dates: any) => {
   return useDate(dates)
}

export default DateTransform


